import ClaimService from './services/ClaimService';
import 'edge/claim/app';

export default angular.module('edge.gateway.claim.app', ['edge.claim.app']).factory('claim.ClaimService', ClaimService).value('claimDetailsLinks', {
    previousPage: 'policies.detail.summary({policyNumber:details.claim.policy.policyNumber})',
    policyDetails: 'policies.detail.summary({policyNumber:details.claim.policy.policyNumber})',
    accountDetails: 'accounts.detail.summary({accountNumber:details.claim.policy.accountNumber})'
}).value('claim.endpointConfig', {
    'uploadEndpoint': 'gatewayclaim/docupload',
    'documentsEndpoint': 'gatewayclaim/docs',
    'downloadEndpoint': 'document/gatewaydocument/claimDocument',
    'sessionServiceName': 'gatewayclaim/docs'
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/claim/app.js
// module id = 1607
// module chunks = 0